import { v4 as uuid } from 'uuid';

import crypto from './crypto';

// https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/digest
async function hashFromString(inputString: string): Promise<string> {
    if (!('subtle' in crypto)) {
        // Secure context: This feature is available only in secure contexts (HTTPS), in some or all supporting browsers. Fallback to uuid
        return uuid();
    }

    const encoder = new TextEncoder();
    const data = encoder.encode(inputString);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
}

export default hashFromString;
